import requests from '@/utils/request.js'

export const getIndustryDataAPI = () => requests({
  method:'POST',
  url:'/api/common/industry',
})

export const getCaseTypeDataAPI = () => requests({
  method:'POST',
  url:'/api/common/getcasetype',
})

export const getGroupDataAPI = () => requests({
  method:'POST',
  url:'/api/common/getgroup',
})

export const getDepartmentDataAPI = () => requests({
  method:'POST',
  url:'/api/common/department',
})

export const getPositionListDataAPI = () => requests({
  method:'POST',
  url:'/api/common/positionlist',
})
export const getJobListDataAPI = (pid) => requests({
  method:'POST',
  url:'/api/common/joblist',
  data: {
    pid
  }
})
export const getCaseCaseSourceAPI = (data)=> requests({
  method:'POST',
  url:'/api/common/getsourcetype',
  data
})
export const getpersonlist = (data)=> requests({
  method:'POST',
  url:'/api/common/getpersonlist',
  data
})


